export default "__VITE_ASSET__Rn3z15zs__"